if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // The following code is for the set-builder template's product form button
          // Check if this button belongs to step 1 section
          const isStepOneButton = this.closest('#builder-step-1');
          // If yes, scroll to step 2 section
          const stepTwoHeader = document.querySelector('#builder-step-2-header')
          if (isStepOneButton && stepTwoHeader) stepTwoHeader.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            isStepOneButton ? this.cart.renderContents(response, false) : this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function getSelectedVariantOptions() {
  const selectedOptions = [];
  const optionElements = document.querySelectorAll('.select__select');

  optionElements.forEach((optionElement) => {
    const selectedOption = optionElement.options[optionElement.selectedIndex].text;
    selectedOptions.push(selectedOption);
  });

  return selectedOptions.join(', ');
}

// // Add this function to get the cart's value
// function getCartValue(callback) {
//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(data => {
//       callback(data.total_price / 100); // Divide by 100 to convert cents to dollars
//     });
// }

// // Add this function to update the free shipping bar
// function updateFreeShippingBar() {
//   getCartValue(cartValue => {
//     updateFreeShippingText(cartValue);
//   });
// }

document.addEventListener('DOMContentLoaded', function () {
  if ( document.location.href.indexOf('/products/') != -1 && document.querySelector(".rbr_template") ){ 
    const addToCartButton = document.querySelector('.product-form__submit.button.button--full-width.button--primary');
    if (!addToCartButton) return;
  
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
  
    const stickyAddToCart = document.createElement('div');
    stickyAddToCart.className = 'sticky-add-to-cart';
  
    const stickyAddToCartInnerTop = document.createElement('div');
    stickyAddToCartInnerTop.className = 'sticky-add-to-cart__inner-top';
    
    const stickyAddToCartInner = document.createElement('div');
    stickyAddToCartInner.className = 'sticky-add-to-cart__inner';
  
    const productInfo = document.createElement('div');
    productInfo.className = 'sticky-add-to-cart__product-info';
  
    const productImage = document.querySelector('.product__media img');
    const smallProductImage = productImage?.cloneNode(true);
    if (smallProductImage) {
      smallProductImage.className = 'sticky-add-to-cart__image';
      productInfo.appendChild(smallProductImage);
    }
  
    const productDetails = document.createElement('div');
    productDetails.className = 'sticky-add-to-cart__product-details';
  
    const productTitle = document.querySelector('.product__title h1')?.textContent;
    const stickyProductTitle = document.createElement('span');
    stickyProductTitle.className = 'sticky-add-to-cart__title';
    stickyProductTitle.textContent = productTitle;
    productDetails.appendChild(stickyProductTitle);
  
    const variantOptions = document.createElement('div');
    variantOptions.className = 'sticky-add-to-cart__variant-options';
    variantOptions.textContent = getSelectedVariantOptions();
    productDetails.appendChild(variantOptions);
  
    const variantOptionsTop = document.createElement('div');
    variantOptionsTop.className = 'sticky-add-to-cart__variant-options';
    variantOptionsTop.textContent = getSelectedVariantOptions();
    stickyAddToCartInnerTop.appendChild(variantOptionsTop);
  
    const productPrice = document.querySelector('.price-item.price-item--regular')?.cloneNode(true);
    if (productPrice) {
      productPrice.className = 'sticky-add-to-cart__price';
      productDetails.appendChild(productPrice);
      productInfo.appendChild(productDetails);
    }
    
    const quantityAndButtonWrapper = document.createElement('div');
    quantityAndButtonWrapper.className = 'sticky-add-to-cart__quantity-button-wrapper';
  
    const quantitySelector = document.querySelector('.product-form__quantity')?.cloneNode(true);
    if (quantitySelector) {
      quantitySelector.id = quantitySelector.id.replace('main', 'sticky');
      quantitySelector.querySelector('label').id = quantitySelector.querySelector('label').id.replace('main', 'sticky');
      quantitySelector.querySelector('input').id = quantitySelector.querySelector('input').id.replace('main', 'sticky');
      quantitySelector.className = 'sticky-add-to-cart__quantity';
      quantityAndButtonWrapper.appendChild(quantitySelector);
    }
  
    const stickyAddToCartButton = addToCartButton?.cloneNode(true);
    if (stickyAddToCartButton) {
      stickyAddToCartButton.className = 'sticky-add-to-cart__button';
      quantityAndButtonWrapper.appendChild(stickyAddToCartButton);
    }
    
    stickyAddToCartInner.appendChild(productInfo);
    stickyAddToCartInner.appendChild(quantityAndButtonWrapper);
  
    // Mimic the click event on the original button when the sticky button is clicked
    stickyAddToCartButton.addEventListener('click', (e) => {
      e.preventDefault();
      addToCartButton.click();
    });
    stickyAddToCart.appendChild(stickyAddToCartInnerTop);
    stickyAddToCart.appendChild(stickyAddToCartInner);
    document.body.appendChild(stickyAddToCart);
  
    window.addEventListener('scroll', function () {
      const buttonRect = addToCartButton.getBoundingClientRect();
      if (buttonRect.top < window.innerHeight && buttonRect.bottom > 0) {
        stickyAddToCart.classList.remove('sticky-add-to-cart--visible');
      } else {
        stickyAddToCart.classList.add('sticky-add-to-cart--visible');
      }
    });
  
    const optionElements = document.querySelectorAll('.select__select');
    optionElements.forEach((optionElement) => {
    optionElement.addEventListener('change', () => {
      const updatedVariantOptions = getSelectedVariantOptions();
      variantOptions.textContent = updatedVariantOptions;
      variantOptionsTop.textContent = updatedVariantOptions;
    });
    // // Update the free shipping bar when the quantity changes
    // quantitySelector.addEventListener('change', updateFreeShippingBar);
  
    // // Update the free shipping bar when the sticky add-to-cart button is clicked
    // stickyAddToCartButton.addEventListener('click', (e) => {
    //   e.preventDefault();
    //   addToCartButton.click();
    //   updateFreeShippingBar();
    // });
  
    // // Update the free shipping bar when the regular add-to-cart button is clicked
    // addToCartButton.addEventListener('click', updateFreeShippingBar);
  
    // // Call updateFreeShippingBar initially
    // updateFreeShippingBar();
    });
    
    const quantityInputs = document.querySelectorAll('.quantity__input');
    quantityInputs.forEach((quantityInput, index, arr) => {
      quantityInput.addEventListener('change', (e) => {
      if (e.target == arr[0]) {
        arr[1].value = e.target.value;
      } else {
        arr[0].value = e.target.value;
      }
      })
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector("#rbr-container-element-true")) {
    document.querySelector(".sticky-add-to-cart").style.display = "none";
  }
});
